import { useState } from "react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { apiErr } from "@/lib/api";
import { X, KeyRound, Loader2 } from "lucide-react";

export default function AccountModal({ open, onClose }) {
  const { user, changePassword } = useAuth();
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  if (!open) return null;

  const submit = async (e) => {
    e.preventDefault();
    if (next !== confirm) { toast.error("Les mots de passe ne correspondent pas"); return; }
    setBusy(true);
    try {
      await changePassword(cur, next);
      toast.success("Mot de passe modifié");
      setCur(""); setNext(""); setConfirm("");
      onClose();
    } catch (e2) { toast.error("Échec", { description: apiErr(e2) }); }
    finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-[2000] flex items-center justify-center bg-black/70 backdrop-blur-sm" onClick={onClose}>
      <div data-testid="account-modal" className="w-full max-w-md mx-4 bg-[#141414] border border-white/15 rounded-sm p-5" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-chivo text-lg font-bold uppercase tracking-tight flex items-center gap-2"><KeyRound size={16} /> Compte</h3>
          <button onClick={onClose} className="w-7 h-7 flex items-center justify-center border border-white/15 rounded-sm hover:bg-white/10"><X size={14} /></button>
        </div>
        <div className="font-mono text-xs text-[#A3A3A3] mb-4">
          <div>{user?.email}</div>
          <div className="text-[#525252] uppercase tracking-wider text-[10px] mt-0.5">{user?.role}</div>
        </div>
        <form onSubmit={submit} className="space-y-3">
          <In label="Mot de passe actuel" value={cur} onChange={setCur} testid="cur-password" />
          <In label="Nouveau mot de passe" value={next} onChange={setNext} testid="new-password" />
          <In label="Confirmer" value={confirm} onChange={setConfirm} testid="confirm-password" />
          <button data-testid="change-password-submit" type="submit" disabled={busy}
            className="w-full flex items-center justify-center gap-2 bg-[#3B82F6] hover:bg-[#2563EB] disabled:opacity-50 text-white font-mono text-xs uppercase tracking-wider py-2.5 rounded-sm">
            {busy ? <Loader2 size={14} className="animate-spin" /> : <KeyRound size={14} />} Modifier le mot de passe
          </button>
        </form>
      </div>
    </div>
  );
}

function In({ label, value, onChange, testid }) {
  return (
    <div>
      <label className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#A3A3A3] block mb-1.5">{label}</label>
      <input data-testid={testid} type="password" value={value} onChange={(e) => onChange(e.target.value)}
        className="w-full bg-[#0A0A0A] border border-white/15 focus:border-[#3B82F6] outline-none rounded-sm px-3 py-2 font-mono text-sm" />
    </div>
  );
}
